/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).ready( function() {
        $( '.ll-woocommerce.ll-product' ).each( function( key, component ) {
          $( component ).find( '.main-slider' ).slick( {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            asNavFor: $( component ).find( '.slider-navigation' )[0],
          } );

          $( component ).find( '.slider-navigation' ).slick( {
            dots: false,
            arrows: true,
            prevArrow: $( component ).find( '.prev-slide' )[0],
            nextArrow: $( component ).find( '.next-slide' )[0],
            slidesToShow: 5,
            asNavFor: $( component ).find( '.main-slider' )[0],
          } );

          $( component ).find( '.slider-navigation .slide button' ).on( 'click', function() {
            $( component ).find( '.main-slider' ).slick( 'slickGoTo', parseInt( $( this ).attr( 'data-slide' ) ) );
          } );
          $( '.ll_single_product_wrap' ).css( 'opacity', '1' );
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'llproduct', COMPONENT );
} )( app );
